module.exports = __webpack_public_path__ + "static/img/functionPic.dbd6c19f.jpg";